import styled from 'styled-components'

const SignInContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;

  h2 {
    margin: 10px 0;
  }
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export { SignInContainer, ButtonContainer }
